import * as React from 'react';
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router-dom';


export class Disclaimer1 extends React.Component<RouteComponentProps<{}>> {
    render() {

        return (
            <h5 className="rep_dimmedText" style={{ lineHeight: '1.5' }}>
                <span >
                    Система OTC Repo System (далее – Система) предназначена для организации интернет-сервиса по взаимному кредитованию кредитных и некредитных организаций под залог ценных бумаг. Сервис предоставляет информационное сопровождение – возможность продавцу ресурсов найти покупателя и наоборот.
                        </span>
                <br />
                <br />
                <span >
                    Сервис не подразумевает под собой торговую платформу с обработкой платежей и сделок. Все участники совершившие операции через сервис оформляют дальнейшие свои действия самостоятельно, посредством договорных отношений на согласованных посредством сервиса условиях.
                        </span>
            </h5>

        );
    }
}

export default withRouter(Disclaimer1);
